exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".package-list{width:80%;margin:1em auto}\n", ""]);

// exports
